import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {BrowserRouter, useLocation} from "react-router-dom";
import AppRouter from "./components/AppRouter";
import NavigationPanel from "./components/NavigationPanel/NavigationPanel";
import {Context} from "./index";
import {Spinner} from "react-bootstrap";
import Footer from "./components/Footer/Footer";
import NonBreakingSpaces from "./components/ui/NonBreakingSpaces";

const ScrollToTop = () => {
    const {pathname} = useLocation();

    useEffect(() => {
        window.scrollTo({top: 0, left: 0});
    }, [pathname]);

    return null;
};

const App = () => {
    const [loading, setLoading] = useState(true);
    const {user} = useContext(Context);

    useEffect(() => {
        user.checkAuth().then(() => setLoading(false))
    }, [user]);

    if (loading) {
        return <Spinner className="spinner" animation={"grow"}/>
    }

    return (
        <BrowserRouter>
            <ScrollToTop/>
            <NonBreakingSpaces/>
            <NavigationPanel/>
            <main>
                <AppRouter/>
            </main>
            <Footer/>
        </BrowserRouter>
    );
};

export default App;
